module.exports = __webpack_public_path__ + "img/10.0de22c9b.png";